import * as styles from './CustomAccordion.css';

export const GoldTitle = () => (
  <svg
    width="285"
    height="24"
    viewBox="0 0 285 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.fancyTitle}
    aria-label="Gold Partners"
    role="heading"
    aria-level={3}
  >
    <g clipPath="url(#clip0_1395_1699)">
      <path
        d="M30.637 19.4184C33.7879 19.4184 36.077 17.7837 36.6427 15.4946H29.5648V11.1235H41.6684V12.9357C41.6684 20.1913 36.3171 23.9967 30.637 23.9967C23.4406 23.9967 18.563 18.6455 18.563 12.0148C18.563 5.38413 24.0655 0 30.6962 0C36.6427 0 40.0929 3.65739 41.1323 6.57147L36.8796 8.65342C36.1954 6.90037 34.3832 4.54872 30.6337 4.54872C26.8842 4.54872 23.4669 7.7588 23.4669 11.9819C23.4669 16.205 26.4106 19.4151 30.6337 19.4151L30.637 19.4184Z"
        fill="#FDC221"
      />
      <path
        d="M56.2095 0C62.8994 0 68.2211 5.20323 68.2211 11.8931C68.2211 18.583 62.781 23.9967 56.0879 23.9967C49.3947 23.9967 44.0435 18.7343 44.0435 12.0148C44.0435 5.29533 49.5197 0 56.2095 0ZM56.1503 19.3296C60.1662 19.3296 63.3171 15.9978 63.3171 11.9852C63.3171 7.97259 60.1662 4.67041 56.1503 4.67041C52.1345 4.67041 48.9836 7.97259 48.9836 11.9852C48.9836 15.9978 52.1345 19.3296 56.1503 19.3296Z"
        fill="#FDC221"
      />
      <path
        d="M76.9926 0.358521V19.0632H86.955V23.6415H72.207V0.358521H76.9959H76.9926Z"
        fill="#FDC221"
      />
      <path
        d="M97.2105 23.6415H90.1621V0.358521H97.2993C105.417 0.358521 110.442 4.64083 110.442 11.9556C110.442 18.8823 105.446 23.6415 97.2105 23.6415ZM97.3618 19.0928C102.18 19.0928 105.509 16.5339 105.509 11.9556C105.509 7.3773 101.999 4.90724 97.421 4.90724H94.9838V19.0895H97.3618V19.0928Z"
        fill="#FDC221"
      />
      <path
        d="M130.426 15.4354H126.769V23.6415H121.95V0.358521H130.604C135.271 0.358521 138.928 2.88449 138.928 7.82131C138.928 12.7581 135.3 15.4321 130.423 15.4321L130.426 15.4354ZM130.216 10.9426C132.12 10.9426 134.08 10.1105 134.08 7.93972C134.08 5.76896 132.176 4.90724 130.186 4.90724H126.765V10.9426H130.216Z"
        fill="#FDC221"
      />
      <path
        d="M137.412 23.6415L146.302 0.358521H152.101L161.021 23.6415H156.054L154.301 18.9448H143.984L142.26 23.6415H137.412ZM152.667 14.4816L149.157 5.02564L145.648 14.4816H152.667Z"
        fill="#FDC221"
      />
      <path
        d="M163.103 0.358521H172.292C176.812 0.358521 180.528 2.79569 180.528 7.73251C180.528 11.061 178.893 13.4127 175.739 14.5408L181.002 23.6415H175.651L170.832 15.2874H167.918V23.6415H163.1V0.358521H163.103ZM175.651 7.82131C175.651 5.59136 173.717 4.90724 171.904 4.90724H167.921V10.8242H171.937C173.72 10.8242 175.654 10.0217 175.654 7.82131H175.651Z"
        fill="#FDC221"
      />
      <path
        d="M188.645 5.02564H181.656V0.358521H200.42V5.02564H193.431V23.6415H188.642V5.02564H188.645Z"
        fill="#FDC221"
      />
      <path
        d="M207.912 23.6415H203.153V0.358521H208.655L218.766 15.5538V0.358521H223.525V23.6415H218.618L207.912 7.5845V23.6415Z"
        fill="#FDC221"
      />
      <path
        d="M243.625 0.358521V4.87764H233.129V9.60725H242.526V14.1264H233.129V19.152H243.687V23.6415H228.374V0.358521H243.628H243.625Z"
        fill="#FDC221"
      />
      <path
        d="M247.489 0.358521H256.679C261.198 0.358521 264.914 2.79569 264.914 7.73251C264.914 11.061 263.28 13.4127 260.126 14.5408L265.388 23.6415H260.037L255.218 15.2874H252.304V23.6415H247.486V0.358521H247.489ZM260.037 7.82131C260.037 5.59136 258.103 4.90724 256.291 4.90724H252.308V10.8242H256.323C258.106 10.8242 260.04 10.0217 260.04 7.82131H260.037Z"
        fill="#FDC221"
      />
      <path
        d="M275.975 9.57764C281.149 11.0643 284.122 12.8798 284.122 16.8036C284.122 20.7274 281.09 24 275.587 24C271.186 24 267.855 21.8589 266.486 18.5304L270.65 16.3892C271.542 18.412 273.387 19.6289 275.735 19.6289C277.817 19.6289 279.274 18.5896 279.274 17.1621C279.274 15.7347 278.264 15.169 274.873 14.1593C272.377 13.4159 270.443 12.5838 269.193 11.334C268.124 10.2914 267.411 8.80801 267.411 7.02207C267.411 2.85817 271.127 0.0032959 275.528 0.0032959C279.422 0.0032959 282.366 1.84844 283.704 5.02892L279.721 7.19968C278.948 5.32494 277.314 4.34481 275.321 4.34481C273.327 4.34481 272.229 5.35454 272.229 6.72277C272.229 8.17981 273.479 8.86392 275.975 9.57764Z"
        fill="#FDC221"
      />
      <path
        d="M3.10813 23.681C4.8247 23.681 6.21625 22.2894 6.21625 20.5728C6.21625 18.8563 4.8247 17.4647 3.10813 17.4647C1.39156 17.4647 0 18.8563 0 20.5728C0 22.2894 1.39156 23.681 3.10813 23.681Z"
        fill="#FEE384"
      />
      <path
        d="M11.7878 15.0572C13.5044 15.0572 14.8959 13.6656 14.8959 11.9491C14.8959 10.2325 13.5044 8.84094 11.7878 8.84094C10.0712 8.84094 8.67969 10.2325 8.67969 11.9491C8.67969 13.6656 10.0712 15.0572 11.7878 15.0572Z"
        fill="#FDD651"
      />
      <path
        d="M3.10813 6.43659C4.8247 6.43659 6.21625 5.04503 6.21625 3.32846C6.21625 1.61189 4.8247 0.220337 3.10813 0.220337C1.39156 0.220337 0 1.61189 0 3.32846C0 5.04503 1.39156 6.43659 3.10813 6.43659Z"
        fill="#FDC221"
      />
      <path
        d="M3.10813 15.0572C4.8247 15.0572 6.21625 13.6656 6.21625 11.9491C6.21625 10.2325 4.8247 8.84094 3.10813 8.84094C1.39156 8.84094 0 10.2325 0 11.9491C0 13.6656 1.39156 15.0572 3.10813 15.0572Z"
        fill="#FDD651"
      />
    </g>
    <defs>
      <clipPath id="clip0_1395_1699">
        <rect width="285" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const KeyMiddlewareTitle = () => (
  <svg
    width="408"
    height="24"
    viewBox="0 0 408 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.fancyTitle}
    aria-label="Key Middleware Partners"
    role="heading"
    aria-level={3}
  >
    <g clipPath="url(#clip0_1395_1789)">
      <path
        d="M18.7566 21.4851V2.19849H22.7209V10.5981L29.3424 2.19849H34.3141L26.9546 11.41L34.8069 21.4851H29.661L22.7181 12.3227V21.4851H18.7539H18.7566Z"
        fill="#6E56E6"
      />
      <path
        d="M49.5011 2.19849V5.94193H40.813V9.85974H48.5917V13.6032H40.813V17.7662H49.5528V21.4851H36.876V2.19849H49.5038H49.5011Z"
        fill="#6E56E6"
      />
      <path
        d="M58.3608 13.8484L51.2954 2.19849H55.8995L60.3538 9.90878L64.8571 2.19849H69.4122L62.3468 13.6767V21.4851H58.3581V13.8484H58.3608Z"
        fill="#6E56E6"
      />
      <path
        d="M89.2525 21.4851H86.5951L81.2532 8.84896H81.2287V21.4851H77.3135V2.19849H82.4594L87.9238 15.1289L93.2902 2.19849H98.5831V21.4851H94.6434V8.75088H94.6189L89.2525 21.4851Z"
        fill="#6E56E6"
      />
      <path
        d="M107.048 21.4851H103.059V2.19849H107.048V21.4851Z"
        fill="#6E56E6"
      />
      <path
        d="M117.386 21.4851H111.551V2.19849H117.46C124.179 2.19849 128.339 5.74577 128.339 11.805C128.339 17.5428 124.204 21.4851 117.386 21.4851ZM117.511 17.7172C121.5 17.7172 124.255 15.5975 124.255 11.805C124.255 8.01254 121.35 5.96645 117.56 5.96645H115.543V17.7144H117.511V17.7172Z"
        fill="#6E56E6"
      />
      <path
        d="M137.523 21.4851H131.688V2.19849H137.596C144.316 2.19849 148.476 5.74577 148.476 11.805C148.476 17.5428 144.34 21.4851 137.523 21.4851ZM137.645 17.7172C141.634 17.7172 144.389 15.5975 144.389 11.805C144.389 8.01254 141.484 5.96645 137.694 5.96645H135.677V17.7144H137.645V17.7172Z"
        fill="#6E56E6"
      />
      <path
        d="M155.787 2.19849V17.6926H164.034V21.4851H151.825V2.19849H155.789H155.787Z"
        fill="#6E56E6"
      />
      <path
        d="M179.316 2.19849V5.94193H170.628V9.85974H178.407V13.6032H170.628V17.7662H179.368V21.4851H166.691V2.19849H179.319H179.316Z"
        fill="#6E56E6"
      />
      <path
        d="M186.899 21.4851L181.238 2.19849H185.497L189.164 15.8945L193.324 2.19849H197.583L201.743 15.9926L205.533 2.19849H209.644L203.935 21.4851H199.627L195.443 7.49489H195.394L191.184 21.4851H186.901H186.899Z"
        fill="#6E56E6"
      />
      <path
        d="M209.148 21.4851L216.508 2.19849H221.308L228.692 21.4851H224.581L223.129 17.5946H214.588L213.162 21.4851H209.148ZM221.776 13.8974L218.871 6.06453L215.966 13.8974H221.776Z"
        fill="#6E56E6"
      />
      <path
        d="M230.908 2.19849H238.516C242.257 2.19849 245.333 4.21733 245.333 8.30679C245.333 11.064 243.98 13.012 241.369 13.9465L245.725 21.4851H241.296L237.307 14.5649H234.894V21.4851H230.906V2.19849H230.908ZM241.296 8.38035C241.296 6.53314 239.695 5.96645 238.194 5.96645H234.897V10.8678H238.222C239.697 10.8678 241.298 10.203 241.298 8.38035H241.296Z"
        fill="#6E56E6"
      />
      <path
        d="M261.53 2.19849V5.94193H252.842V9.85974H260.621V13.6032H252.842V17.7662H261.579V21.4851H248.902V2.19849H261.53Z"
        fill="#6E56E6"
      />
      <path
        d="M278.414 14.6875H275.386V21.4851H271.397V2.19849H278.561C282.424 2.19849 285.452 4.29089 285.452 8.38035C285.452 12.4698 282.449 14.6848 278.411 14.6848L278.414 14.6875ZM278.242 10.9659C279.819 10.9659 281.441 10.2766 281.441 8.47843C281.441 6.68027 279.865 5.96645 278.218 5.96645H275.386V10.9659H278.242Z"
        fill="#6E56E6"
      />
      <path
        d="M284.2 21.4851L291.559 2.19849H296.359L303.743 21.4851H299.632L298.181 17.5946H289.64L288.213 21.4851H284.2ZM296.828 13.8974L293.922 6.06453L291.017 13.8974H296.828Z"
        fill="#6E56E6"
      />
      <path
        d="M305.467 2.19849H313.074C316.815 2.19849 319.891 4.21733 319.891 8.30679C319.891 11.064 318.538 13.012 315.927 13.9465L320.283 21.4851H315.854L311.865 14.5649H309.453V21.4851H305.464V2.19849H305.467ZM315.854 8.38035C315.854 6.53314 314.253 5.96645 312.752 5.96645H309.453V10.8678H312.777C314.253 10.8678 315.854 10.203 315.854 8.38035Z"
        fill="#6E56E6"
      />
      <path
        d="M326.611 6.06453H320.825V2.19849H336.358V6.06453H330.572V21.4851H326.608V6.06453H326.611Z"
        fill="#6E56E6"
      />
      <path
        d="M342.56 21.4851H338.623V2.19849H343.178L351.548 14.7856V2.19849H355.487V21.4851H351.425L342.563 8.18418V21.4851H342.56Z"
        fill="#6E56E6"
      />
      <path
        d="M372.123 2.19849V5.94193H363.435V9.85974H371.214V13.6032H363.435V17.7662H372.172V21.4851H359.496V2.19849H372.123Z"
        fill="#6E56E6"
      />
      <path
        d="M375.323 2.19849H382.93C386.671 2.19849 389.747 4.21733 389.747 8.30679C389.747 11.064 388.394 13.012 385.783 13.9465L390.139 21.4851H385.71L381.721 14.5649H379.309V21.4851H375.32V2.19849H375.323ZM385.71 8.38035C385.71 6.53314 384.109 5.96645 382.608 5.96645H379.309V10.8678H382.633C384.109 10.8678 385.71 10.203 385.71 8.38035Z"
        fill="#6E56E6"
      />
      <path
        d="M398.904 9.83528C403.187 11.0667 405.648 12.5707 405.648 15.821C405.648 19.0713 403.138 21.7822 398.583 21.7822C394.94 21.7822 392.181 20.0085 391.049 17.2513L394.496 15.4777C395.234 17.1532 396.761 18.1613 398.705 18.1613C400.428 18.1613 401.635 17.3004 401.635 16.1179C401.635 14.9355 400.799 14.4669 397.992 13.6305C395.925 13.0148 394.324 12.3255 393.29 11.2902C392.405 10.4265 391.814 9.19775 391.814 7.71835C391.814 4.26915 394.891 1.9043 398.533 1.9043C401.757 1.9043 404.194 3.43273 405.302 6.06731L402.002 7.86547C401.362 6.31252 400.009 5.50062 398.359 5.50062C396.709 5.50062 395.8 6.33704 395.8 7.47042C395.8 8.67737 396.835 9.24406 398.901 9.83528H398.904Z"
        fill="#6E56E6"
      />
      <path
        d="M4.78095 21.5179C6.20194 21.5179 7.35389 20.3652 7.35389 18.9433C7.35389 17.5214 6.20194 16.3687 4.78095 16.3687C3.35995 16.3687 2.20801 17.5214 2.20801 18.9433C2.20801 20.3652 3.35995 21.5179 4.78095 21.5179Z"
        fill="#B5A7F4"
        stroke="#B5A7F4"
        strokeMiterlimit="10"
      />
      <path
        d="M11.966 14.3744C13.387 14.3744 14.5389 13.2217 14.5389 11.7997C14.5389 10.3778 13.387 9.2251 11.966 9.2251C10.545 9.2251 9.39307 10.3778 9.39307 11.7997C9.39307 13.2217 10.545 14.3744 11.966 14.3744Z"
        fill="#937FEF"
        stroke="#937FEF"
        strokeMiterlimit="10"
      />
      <path
        d="M4.78095 7.23351C6.20194 7.23351 7.35389 6.0808 7.35389 4.65887C7.35389 3.23693 6.20194 2.08423 4.78095 2.08423C3.35995 2.08423 2.20801 3.23693 2.20801 4.65887C2.20801 6.0808 3.35995 7.23351 4.78095 7.23351Z"
        fill="#6E56E6"
      />
      <path
        d="M4.78095 14.3744C6.20194 14.3744 7.35389 13.2217 7.35389 11.7997C7.35389 10.3778 6.20194 9.2251 4.78095 9.2251C3.35995 9.2251 2.20801 10.3778 2.20801 11.7997C2.20801 13.2217 3.35995 14.3744 4.78095 14.3744Z"
        fill="#937FEF"
        stroke="#937FEF"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1395_1789">
        <rect width="408" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlatinumTitle = () => (
  <svg
    width="356"
    height="24"
    viewBox="0 0 356 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.fancyTitle}
    aria-label="Platinum Partners"
    role="heading"
    aria-level={3}
  >
    <g clipPath="url(#clip0_1395_1650)">
      <path
        d="M28.4701 15.4342H24.8122V23.6414H19.9932V0.355225H28.6478C33.3155 0.355225 36.9734 2.88154 36.9734 7.81904C36.9734 12.7565 33.3451 15.4309 28.4668 15.4309L28.4701 15.4342ZM28.2629 10.9408C30.1675 10.9408 32.128 10.1085 32.128 7.93746C32.128 5.76641 30.2234 4.90457 28.2333 4.90457H24.8122V10.9408H28.2629Z"
        fill="#414C63"
      />
      <path
        d="M44.4703 0.355225V19.0625H54.4341V23.6414H39.6841V0.355225H44.4736H44.4703Z"
        fill="#414C63"
      />
      <path
        d="M55.2925 23.6414L64.1839 0.355225H69.9833L78.9043 23.6414H73.9372L72.1839 18.944H61.8648L60.1412 23.6414H55.2925ZM70.5491 14.4802L67.0392 5.02299L63.5293 14.4802H70.5491Z"
        fill="#414C63"
      />
      <path
        d="M83.7533 5.02299H76.7632V0.355225H95.5296V5.02299H88.5395V23.6414H83.75V5.02299H83.7533Z"
        fill="#414C63"
      />
      <path
        d="M103.082 23.6414H98.2632V0.355225H103.082V23.6414Z"
        fill="#414C63"
      />
      <path
        d="M112.688 23.6414H107.928V0.355225H113.431L123.543 15.5526V0.355225H128.303V23.6414H123.395L112.688 7.5822V23.6414Z"
        fill="#414C63"
      />
      <path
        d="M142.22 23.9671C135.766 23.9671 132.911 20.0427 132.911 14.421V0.355225H137.76L137.73 14.3026C137.73 17.7533 139.724 19.3289 142.25 19.3289C145.224 19.3289 146.858 17.3651 146.858 14.421V0.355225H151.618V14.2434C151.618 20.1908 148.526 23.9671 142.22 23.9671Z"
        fill="#414C63"
      />
      <path
        d="M170.618 23.6414H167.408L160.954 8.38483H160.924V23.6414H156.194V0.355225H162.411L169.013 15.9671L175.496 0.355225H181.891V23.6414H177.131V8.26641H177.102L170.618 23.6414Z"
        fill="#414C63"
      />
      <path
        d="M202.053 15.4342H198.395V23.6414H193.576V0.355225H202.23C206.898 0.355225 210.556 2.88154 210.556 7.81904C210.556 12.7565 206.928 15.4309 202.049 15.4309L202.053 15.4342ZM201.845 10.9408C203.75 10.9408 205.711 10.1085 205.711 7.93746C205.711 5.76641 203.806 4.90457 201.816 4.90457H198.395V10.9408H201.845Z"
        fill="#414C63"
      />
      <path
        d="M209.04 23.6414L217.931 0.355225H223.73L232.651 23.6414H227.684L225.931 18.944H215.612L213.888 23.6414H209.04ZM224.296 14.4802L220.786 5.02299L217.276 14.4802H224.296Z"
        fill="#414C63"
      />
      <path
        d="M234.733 0.355225H243.924C248.444 0.355225 252.161 2.79272 252.161 7.73022C252.161 11.0592 250.526 13.4111 247.371 14.5394L252.635 23.6414H247.283L242.464 15.2861H239.549V23.6414H234.73V0.355225H234.733ZM247.286 7.81904C247.286 5.58878 245.352 4.90457 243.539 4.90457H239.556V10.8223H243.572C245.355 10.8223 247.289 10.0197 247.289 7.81904H247.286Z"
        fill="#414C63"
      />
      <path
        d="M260.28 5.02299H253.29V0.355225H272.056V5.02299H265.066V23.6414H260.276V5.02299H260.28Z"
        fill="#414C63"
      />
      <path
        d="M279.549 23.6414H274.79V0.355225H280.293L290.405 15.5526V0.355225H295.165V23.6414H290.257L279.549 7.5822V23.6414Z"
        fill="#414C63"
      />
      <path
        d="M315.266 0.355225V4.87496H304.77V9.60522H314.168V14.125H304.77V19.1513H315.326V23.6414H300.01V0.355225H315.266Z"
        fill="#414C63"
      />
      <path
        d="M319.132 0.355225H328.323C332.842 0.355225 336.559 2.79272 336.559 7.73022C336.559 11.0592 334.924 13.4111 331.77 14.5394L337.033 23.6414H331.681L326.862 15.2861H323.947V23.6414H319.128V0.355225H319.132ZM331.684 7.81904C331.684 5.58878 329.75 4.90457 327.938 4.90457H323.951V10.8223H327.967C329.75 10.8223 331.684 10.0197 331.684 7.81904Z"
        fill="#414C63"
      />
      <path
        d="M347.621 9.57566C352.796 11.0625 355.77 12.8783 355.77 16.8026C355.77 20.727 352.737 24 347.233 24C342.832 24 339.5 21.8586 338.131 18.5296L342.296 16.3882C343.187 18.4112 345.033 19.6283 347.381 19.6283C349.464 19.6283 350.921 18.5888 350.921 17.1612C350.921 15.7336 349.911 15.1678 346.52 14.1579C344.023 13.4145 342.089 12.5822 340.839 11.3322C339.769 10.2895 339.056 8.80592 339.056 7.01974C339.056 2.85526 342.773 0 347.174 0C351.069 0 354.013 1.84539 355.352 5.02632L351.365 7.19737C350.592 5.32237 348.957 4.34211 346.964 4.34211C344.97 4.34211 343.871 5.35197 343.871 6.72039C343.871 8.17763 345.121 8.86184 347.618 9.57566H347.621Z"
        fill="#414C63"
      />
      <path
        d="M3.10855 23.681C4.82536 23.681 6.21711 22.2892 6.21711 20.5724C6.21711 18.8556 4.82536 17.4639 3.10855 17.4639C1.39175 17.4639 0 18.8556 0 20.5724C0 22.2892 1.39175 23.681 3.10855 23.681Z"
        fill="#838FA5"
      />
      <path
        d="M11.7897 15.056C13.5065 15.056 14.8983 13.6642 14.8983 11.9474C14.8983 10.2306 13.5065 8.83887 11.7897 8.83887C10.0729 8.83887 8.68115 10.2306 8.68115 11.9474C8.68115 13.6642 10.0729 15.056 11.7897 15.056Z"
        fill="#5A6881"
      />
      <path
        d="M3.10855 6.43427C4.82536 6.43427 6.21711 5.04252 6.21711 3.32572C6.21711 1.60891 4.82536 0.217163 3.10855 0.217163C1.39175 0.217163 0 1.60891 0 3.32572C0 5.04252 1.39175 6.43427 3.10855 6.43427Z"
        fill="#414C63"
      />
      <path
        d="M3.10855 15.056C4.82536 15.056 6.21711 13.6642 6.21711 11.9474C6.21711 10.2306 4.82536 8.83887 3.10855 8.83887C1.39175 8.83887 0 10.2306 0 11.9474C0 13.6642 1.39175 15.056 3.10855 15.056Z"
        fill="#5A6881"
      />
    </g>
    <defs>
      <clipPath id="clip0_1395_1650">
        <rect width="356" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SilverTitle = () => (
  <svg
    width="300"
    height="24"
    viewBox="0 0 300 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.fancyTitle}
    aria-label="Silver Partners"
    role="heading"
    aria-level={3}
  >
    <g clipPath="url(#clip0_1395_1744)">
      <path
        d="M27.3388 9.57566C32.5131 11.0625 35.4868 12.8783 35.4868 16.8026C35.4868 20.727 32.4539 24 26.9506 24C22.5493 24 19.2171 21.8586 17.8486 18.5296L22.0131 16.3882C22.9046 18.4112 24.7499 19.6283 27.0986 19.6283C29.1809 19.6283 30.6381 18.5888 30.6381 17.1612C30.6381 15.7336 29.6282 15.1678 26.2368 14.1579C23.7401 13.4145 21.8059 12.5822 20.5559 11.3322C19.4868 10.2895 18.773 8.80592 18.773 7.01974C18.773 2.85526 22.4901 0 26.8914 0C30.7861 0 33.7302 1.84539 35.069 5.02632L31.0855 7.19737C30.3125 5.32237 28.6776 4.34211 26.6842 4.34211C24.6907 4.34211 23.5921 5.35197 23.5921 6.72039C23.5921 8.17763 24.8421 8.86184 27.3388 9.57566Z"
        fill="#838FA5"
      />
      <path
        d="M44.2004 23.6414H39.3813V0.355225H44.2004V23.6414Z"
        fill="#838FA5"
      />
      <path
        d="M54.4307 0.355225V19.0625H64.3945V23.6414H49.6445V0.355225H54.434H54.4307Z"
        fill="#838FA5"
      />
      <path
        d="M67.901 0.355225L73.9371 18.0493L80.0029 0.355225H85.1181L76.6707 23.6414H71.1082L62.6904 0.355225H67.8944H67.901Z"
        fill="#838FA5"
      />
      <path
        d="M103.53 0.355225V4.87496H93.0329V9.60522H102.431V14.125H93.0329V19.1513H103.592V23.6414H88.2764V0.355225H103.533H103.53Z"
        fill="#838FA5"
      />
      <path
        d="M107.99 0.355225H117.181C121.701 0.355225 125.418 2.79272 125.418 7.73022C125.418 11.0592 123.783 13.4111 120.628 14.5394L125.891 23.6414H120.539L115.72 15.2861H112.806V23.6414H107.987V0.355225H107.99ZM120.539 7.81904C120.539 5.58878 118.605 4.90457 116.793 4.90457H112.809V10.8223H116.826C118.609 10.8223 120.543 10.0197 120.543 7.81904H120.539Z"
        fill="#838FA5"
      />
      <path
        d="M145.667 15.4342H142.01V23.6414H137.19V0.355225H145.845C150.513 0.355225 154.171 2.88154 154.171 7.81904C154.171 12.7565 150.542 15.4309 145.664 15.4309L145.667 15.4342ZM145.46 10.9408C147.365 10.9408 149.325 10.1085 149.325 7.93746C149.325 5.76641 147.421 4.90457 145.431 4.90457H142.01V10.9408H145.46Z"
        fill="#838FA5"
      />
      <path
        d="M152.658 23.6414L161.549 0.355225H167.348L176.27 23.6414H171.302L169.549 18.944H159.23L157.506 23.6414H152.658ZM167.914 14.4802L164.404 5.02299L160.895 14.4802H167.914Z"
        fill="#838FA5"
      />
      <path
        d="M178.352 0.355225H187.543C192.062 0.355225 195.78 2.79272 195.78 7.73022C195.78 11.0592 194.145 13.4111 190.99 14.5394L196.253 23.6414H190.901L186.082 15.2861H183.168V23.6414H178.349V0.355225H178.352ZM190.901 7.81904C190.901 5.58878 188.967 4.90457 187.155 4.90457H183.171V10.8223H187.187C188.97 10.8223 190.905 10.0197 190.905 7.81904H190.901Z"
        fill="#838FA5"
      />
      <path
        d="M203.898 5.02299H196.908V0.355225H215.674V5.02299H208.684V23.6414H203.895V5.02299H203.898Z"
        fill="#838FA5"
      />
      <path
        d="M223.168 23.6414H218.408V0.355225H223.911L234.023 15.5526V0.355225H238.783V23.6414H233.875L223.168 7.5822V23.6414Z"
        fill="#838FA5"
      />
      <path
        d="M258.885 0.355225V4.87496H248.388V9.60522H257.786V14.125H248.388V19.1513H258.947V23.6414H243.631V0.355225H258.888H258.885Z"
        fill="#838FA5"
      />
      <path
        d="M262.75 0.355225H271.941C276.46 0.355225 280.178 2.79272 280.178 7.73022C280.178 11.0592 278.543 13.4111 275.388 14.5394L280.651 23.6414H275.299L270.48 15.2861H267.566V23.6414H262.747V0.355225H262.75ZM275.299 7.81904C275.299 5.58878 273.365 4.90457 271.553 4.90457H267.569V10.8223H271.585C273.368 10.8223 275.303 10.0197 275.303 7.81904H275.299Z"
        fill="#838FA5"
      />
      <path
        d="M291.237 9.57566C296.411 11.0625 299.385 12.8783 299.385 16.8026C299.385 20.727 296.352 24 290.849 24C286.447 24 283.115 21.8586 281.747 18.5296L285.911 16.3882C286.803 18.4112 288.648 19.6283 290.997 19.6283C293.079 19.6283 294.536 18.5888 294.536 17.1612C294.536 15.7336 293.526 15.1678 290.135 14.1579C287.638 13.4145 285.704 12.5822 284.454 11.3322C283.385 10.2895 282.671 8.80592 282.671 7.01974C282.671 2.85526 286.388 0 290.789 0C294.684 0 297.628 1.84539 298.967 5.02632L294.983 7.19737C294.21 5.32237 292.576 4.34211 290.582 4.34211C288.589 4.34211 287.49 5.35197 287.49 6.72039C287.49 8.17763 288.74 8.86184 291.237 9.57566Z"
        fill="#838FA5"
      />
      <path
        d="M3.10855 23.681C4.82536 23.681 6.21711 22.2892 6.21711 20.5724C6.21711 18.8556 4.82536 17.4639 3.10855 17.4639C1.39175 17.4639 0 18.8556 0 20.5724C0 22.2892 1.39175 23.681 3.10855 23.681Z"
        fill="#D2D7DF"
      />
      <path
        d="M11.7897 15.056C13.5065 15.056 14.8983 13.6642 14.8983 11.9474C14.8983 10.2306 13.5065 8.83887 11.7897 8.83887C10.0729 8.83887 8.68115 10.2306 8.68115 11.9474C8.68115 13.6642 10.0729 15.056 11.7897 15.056Z"
        fill="#ABB3C1"
      />
      <path
        d="M3.10855 6.43415C4.82536 6.43415 6.21711 5.0424 6.21711 3.32559C6.21711 1.60879 4.82536 0.217041 3.10855 0.217041C1.39175 0.217041 0 1.60879 0 3.32559C0 5.0424 1.39175 6.43415 3.10855 6.43415Z"
        fill="#838FA5"
      />
      <path
        d="M3.10855 15.056C4.82536 15.056 6.21711 13.6642 6.21711 11.9474C6.21711 10.2306 4.82536 8.83887 3.10855 8.83887C1.39175 8.83887 0 10.2306 0 11.9474C0 13.6642 1.39175 15.056 3.10855 15.056Z"
        fill="#ABB3C1"
      />
    </g>
    <defs>
      <clipPath id="clip0_1395_1744">
        <rect width="300" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
